import { useTheme } from '@mui/material';
import { Warning2 } from 'iconsax-react';
import type { FC, ReactNode } from 'react';

import { Banner } from './Banner';

type Props = {
  title?: string;
  children: ReactNode;
};

export const WarningBanner: FC<Props> = ({ title, children }) => {
  const theme = useTheme();
  return (
    <Banner
      backgroundColor={theme.palette.SlabYellow['100']}
      icon={<Warning2 color={theme.palette.SlabYellow['800']} size='24px' />}
      title={title}
    >
      {children}
    </Banner>
  );
};
